<app-dialog [size]="DialogSize.LARGE" [dataSelector]="dataSelector + '-dialog'">
  <app-dialog-header [dataSelector]="dataSelector + '-header'" emitCloseEvent="true" (closeDialog)="onCancel()">Invite</app-dialog-header>

  <span class="body-300 color-gray-300" [dataSelector]="dataSelector + '-description'">
    Enter an email to invite someone, and choose the items they should get access to. They'll receive a notification with access.
  </span>

  <div class="invite-panes">
    <form [formGroup]="inviteForm" class="invite-form" [dataSelector]="dataSelector + '-form'">
      <div class="form-control" [dataSelector]="dataSelector + '-display-name-field'">
        <label [dataSelector]="dataSelector + '-display-name-label'" for="crl-invite-display-name">Display Name</label>
        <input
          id="crl-invite-display-name"
          type="text"
          formControlName="displayName"
          name="crl-invite-display-name"
          class="form-input mt-2"
          [class.form-input--invalid]="inviteForm.controls.displayName.touched && inviteForm.controls.displayName.invalid"
          [dataSelector]="dataSelector + '-display-name-input'"
        />

        @if (inviteForm.controls.displayName.touched && inviteForm.controls.displayName.errors?.required) {
          <mat-error class="d-block small-300 color-red-200 mt-2" [dataSelector]="dataSelector + '-display-name-required-error'">
            Display name is required.
          </mat-error>
        }
      </div>

      <div class="form-control mt-4" [dataSelector]="dataSelector + '-email-field'">
        <label [dataSelector]="dataSelector + '-email-label'" for="crl-invite-email">Email</label>
        <input
          id="crl-invite-email"
          type="email"
          formControlName="email"
          name="crl-invite-email"
          class="form-input mt-2"
          [class.form-input--invalid]="inviteForm.controls.email.touched && inviteForm.controls.email.invalid"
          [dataSelector]="dataSelector + '-email-input'"
        />

        @if (inviteForm.controls.email.touched && inviteForm.controls.email.errors?.required) {
          <mat-error class="d-block small-300 color-red-200 mt-2" [dataSelector]="dataSelector + '-email-required-error'">
            Email is required.
          </mat-error>
        } @else if (inviteForm.controls.email.touched && inviteForm.controls.email.errors?.email) {
          <mat-error class="d-block small-300 color-red-200 mt-2" [dataSelector]="dataSelector + '-email-invalid-error'">
            Invalid email address.
          </mat-error>
        }
      </div>

      <div class="form-control mt-4" [dataSelector]="dataSelector + '-message-field'">
        <label [dataSelector]="dataSelector + '-message-label'" for="crl-invite-message">Message (optional)</label>
        <textarea
          id="crl-invite-message"
          formControlName="message"
          name="crl-invite-message"
          class="form-input mt-2"
          [dataSelector]="dataSelector + '-message-textarea'"
        ></textarea>
      </div>
    </form>

    <section class="invite-tree-pane" [dataSelector]="dataSelector + '-items'">
      <div class="invite-tree-header">
        <span class="invite-tree-title body-400 color-gray-200" [dataSelector]="dataSelector + '-items-title'">{{ treeHeading() }}</span>

        @if (itemTree(); as tree) {
          <span class="invite-tree-header-actions">
            @if (tree.canExpandAll()) {
              <button
                type="button"
                class="invite-tree-link"
                [dataSelector]="dataSelector + '-expand-all'"
                (click)="onExpandAll()"
              >
                Expand All
              </button>
            }

            @if (tree.canExpandAll() && tree.canCollapseAll()) {
              <span class="invite-tree-link-separator">/</span>
            }

            @if (tree.canCollapseAll()) {
              <button
                type="button"
                class="invite-tree-link"
                [dataSelector]="dataSelector + '-collapse-all'"
                (click)="onCollapseAll()"
              >
                Collapse All
              </button>
            }
          </span>
        }
      </div>

      <cxp-crl-invite-item-tree
        class="invite-tree-scroll"
        [scrollToItemId]="data.itemId"
        [sections]="treeSections()"
        [selectedItemIds]="selectedItemIdList()"
        (selectionChange)="onSelectionChange($event)"
      />

      @if (!hasSelection()) {
        <span class="d-block small-300 color-red-200" [dataSelector]="dataSelector + '-no-selection-hint'">Select at least one item.</span>
      }
    </section>
  </div>

  <app-dialog-footer [showCancel]="false" [dataSelector]="dataSelector + '-footer'">
    <div class="w-100 d-flex justify-content-between" [dataSelector]="dataSelector + '-actions'">
      <button andButton color="default" type="button" (click)="onCancel()" [dataSelector]="dataSelector + '-cancel-button'">
        Cancel
      </button>

      <button
        andButton
        color="primary"
        type="button"
        [disabled]="!hasSelection()"
        [isLoading]="isSubmitting()"
        (click)="onSend()"
        [dataSelector]="dataSelector + '-send-button'"
      >
        Send
      </button>
    </div>
  </app-dialog-footer>
</app-dialog>
